module.exports = __webpack_public_path__ + "static/media/Support.e83e809d.svg";